import React from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { useToggle } from 'react-use-v13';
import { Button, Chip, Tag } from '@scale/scaleui';
import { ProjectWebinarScheduleModal } from '../Dashboard/ProjectWebinarScheduleModal';
import _ from 'lodash';

interface WebinarSessionCardProps {
  collection: any[];
  user: IUserJson;
  optional?: boolean;
}

const WebinarSessionCard = ({ collection, user, optional }: WebinarSessionCardProps) => {
  const [showModal, toggleModal] = useToggle(false);
  const firstSession = collection[0];
  const description =
    (firstSession.description ?? '').length < 50
      ? firstSession.description
      : `${firstSession.description.slice(0, 50)}...`;
  const rsvpUsers = _.flatten(collection.map((s: any) => s.rsvpUsers));

  return (
    <div>
      <div className="flex items-center justify-between px-3 py-4 border rounded-lg bg-neutral-0 border-neutral-200 max-sm:flex-wrap max-sm:gap-4">
        <div className="ml-3 flex flex-col gap-1">
          <div className="flex gap-2 items-center text-sm font-medium text-neutral-700">
            {firstSession.name}
            <Tag variant="info" icon={['far', 'laptop']}>
              Live Webinar
            </Tag>
          </div>
          <div className="text-xs text-neutral-600">{description}</div>
          <div className="flex gap-1 mt-1">
            <Chip label={formatDuration(firstSession.duration)} />
            <Chip label="Virtual" />
            {optional && <Chip label="Optional" />}
          </div>
        </div>
        <div>
          <Button
            variant="neutral"
            onClick={toggleModal}
            disabled={false}
            className="whitespace-nowrap"
          >
            {rsvpUsers.includes(user?._id) ? 'Modify Registration' : 'Register'}
          </Button>
        </div>
        <ProjectWebinarScheduleModal
          showModal={showModal}
          toggleModal={toggleModal}
          sessions={collection}
          optional={optional}
        />
      </div>
    </div>
  );
};

export default WebinarSessionCard;

export const formatDuration = (minutes: number): string => {
  let s = '';
  if (minutes % 60 > 0) s += `${minutes % 60} min`;
  if (Math.floor(minutes / 60) === 1) s = `${Math.floor(minutes / 60)} hour ` + s;
  else if (Math.floor(minutes / 60) > 0) s = `${Math.floor(minutes / 60)} hours ` + s;
  return s;
};
